import React from 'react';
import * as Yup from 'yup';

export const SaleOrderPaymentValidatorSchema = Yup.object().shape({
    amount: Yup.number().nullable(true),
    paymentSystem: Yup.object().required('required'),
    status: Yup.object().required('required')
});